import usePromoCountdown from "../../../../../context/usePromoCountdown"
import useStrings from "../../../../../localization/useStrings"
import styles from "./Timer.module.scss"

const Timer = () => {
  const strings = useStrings().premiumToUltimateBlackFriday
  const { minutes, hours, seconds, hourUnit, minuteUnit, secondUnit } =
    usePromoCountdown()

  return (
    <div className={styles.container}>
      <label className={styles.timeRemaining}>{strings.timeRemaining}</label>
      <div className={styles.timeContainer}>
        <TimerItem value={hours.toString()} unit={hourUnit} />
        <TimerSpacer />
        <TimerItem value={minutes.toString()} unit={minuteUnit} />
        <TimerSpacer />
        <TimerItem value={seconds.toString()} unit={secondUnit} />
      </div>
    </div>
  )
}

const TimerSpacer = () => {
  return <div className={styles.timerSpacer} />
}

const TimerItem = ({ value, unit }: { value: string; unit: string }) => {
  return (
    <div className={styles.timerItemContainer}>
      <label className={styles.value}>{value}</label>
      <label className={styles.unit}>{unit.toUpperCase()}</label>
    </div>
  )
}

export default Timer
